import { useState } from 'react';
import { useDispatch } from 'react-redux';

import ShipOrder from './ShipOrder';

import { orderDelivered } from '../../../../actions/orders';

import {
    Stack, Typography, Tooltip, IconButton, Alert
} from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const EnvioAlmacen = ({ selectedOrder, setSelectedOrder }) => {
    const dispatch = useDispatch();
    const { id, order_num, shipping: { status } } = selectedOrder;

    const [loading, setLoading] = useState(false);

    const markAsDelivered = async () => {
        if (id.length === 24) { // validación básica
            setLoading(true);
            dispatch(orderDelivered({ id, order_num }, setSelectedOrder, setLoading));
        } else alert('No se pudo recuperar ID de pedido');
    };

    return (
        <>
            {
                status === 'preparing' &&
                    <ShipOrder
                        selectedOrder={ selectedOrder }
                        setSelectedOrder={ setSelectedOrder } />
            }
            {
                status === 'shipped' &&
                    <Stack direction="row"
                        justifyContent="flex-start"
                        alignItems="center">
                        <LoadingButton
                            endIcon={<CheckCircleIcon />}
                            loading={ loading }
                            loadingPosition="end"
                            variant="contained"
                            onClick={ markAsDelivered }>
                            Entregado
                        </LoadingButton>
                        <Tooltip
                            title={
                                <Typography variant="caption">
                                    Marcar como entregado y actualizar pedido
                                </Typography>
                            }
                        >
                            <IconButton>
                                <HelpOutlineIcon />
                            </IconButton>
                        </Tooltip>
                    </Stack>
            }
            {
                status === 'delivered' &&
                    <Alert severity="success">Pedido entregado con éxito</Alert>
            }
        </>
    );
};

export default EnvioAlmacen;